import banner from "./banner.png";
import elementarySchool from "./elementarySchool.png";
import konkoor from "./konkoor.png";
import middleSchool1 from "./middleSchool1.png";
import middleSchool2 from "./middleSchool2.png";
import productBlue from "./product-blue.png";
import productPink from "./product-pink.png";
import productPurple from "./product-purple.png";
import shiraz from "./shiraz.svg";
import amoozeshParvaresh from "./amoozesh-parvaresh.svg";
import chatinoo from "./chatinoo.svg";
import khajeNasir from "./khaje-nasir.svg";
import sharif from "./sharif.svg";
import students from "./students.png";
import contents from "./contents.png";
import quality from "./quality.png";
import emptyContentImage from "@/assets/images/emptyContent.svg";
import emptyFavoritesImage from "@/assets/images/emptyFavorit.svg";
import emptySupportImage from "@/assets/images/emptySupport.svg";
import empyOrdersImage from "@/assets/images/empyOrders.svg";
import privacy from "./privacy.png";
import policy from "./policy.png";
import faq from "./faq.png";
import contactUs from "./contact-us.png";
import linearBg from "./linear-bg.png";
import linearBgMobile from "./linear-bg-mobile.png";
import aboutUs from "./about.png";
import about1 from "./about-1.png";
import about2 from "./about-2.png";
import about3 from "./about-3.png";
import about4 from "./about-4.png";
import about5 from "./about-5.png";
import news1 from "./news-1.png";
import filePicking from "./filePicking.png";
import opportunities from "./opportunities.png";
import opportunities1 from "./opportunities1.png";
import opportunities2 from "./opportunities2.png";
import opportunities3 from "./opportunities3.png";
import opportunities4 from "./opportunities4.png";
import productPlaceholder from "./product-placeholder.png";
import opportunitiesReadmeOpen from "./readme-why-set.png";
import opportunitiesReadmeClosed from "./opportunities-readme-closed.svg";
import opportunitiesReadmeOpenMobile from "./opportunities-readme-open-mobile.svg";
import opportunitiesReadmeClosedMobile from "./opportunities-readme-closed-mobile.svg";
import dragAndDrop from "./drag&drop.png";
import categoryMobileBg from "./cat-bg.png";
import emptyBasket from "./emptyBasket.svg";
import emptyFilter from "./emptyFilter.svg";
import notFound from "./404.svg";
import welcomemb from "./welcomemobile.png";
import welcomedt from "./welcomedesktop.png";
import call from "./call.png";
import sighn from "./sighn.png";
import curvedItemLanding from "./curved-item.png";
import curvedCircleLanding from "./curved-circle.png";
import setStoreLanding from "./set-store.png";
import lapwPeople from './laptopwpeople.png';
import deskwPlayBtn from './deskwPlayBtn.png';
import dart from './dart.png';
import brain from './brain.png';
import brainwHead from './brainwHead.png';
import puzzle from './puzzle.png'

const baseImages = {
  banner,
  elementarySchool,
  konkoor,
  middleSchool1,
  middleSchool2,
  productBlue,
  productPink,
  productPurple,
  shiraz,
  amoozeshParvaresh,
  chatinoo,
  khajeNasir,
  sharif,
  students,
  contents,
  quality,
  emptyContentImage,
  emptyFavoritesImage,
  emptySupportImage,
  empyOrdersImage,
  privacy,
  policy,
  contactUs,
  faq,
  aboutUs,
  linearBg,
  linearBgMobile,
  about1,
  about2,
  about3,
  about4,
  about5,
  news1,
  filePicking,
  opportunities,
  opportunities1,
  opportunities2,
  opportunities3,
  opportunities4,
  productPlaceholder,
  opportunitiesReadmeClosed,
  opportunitiesReadmeOpen,
  opportunitiesReadmeOpenMobile,
  opportunitiesReadmeClosedMobile,
  dragAndDrop,
  categoryMobileBg,
  emptyBasket,
  notFound,
  emptyFilter,
  welcomedt,
  welcomemb,
  call,
  sighn,
  curvedItemLanding,
  curvedCircleLanding,
  setStoreLanding,
  deskwPlayBtn,
  lapwPeople,
  puzzle,
  brainwHead,
  brain,
  dart
};

export default baseImages;
